export function authHeaders(token: string | null | undefined, headers: Record<string, string> = {}): Record<string, string> {
  return token ? { ...headers, Authorization: `Bearer ${token}` } : { ...headers };
}

export function jsonAuthHeaders(token: string | null | undefined): Record<string, string> {
  return authHeaders(token, { 'Content-Type': 'application/json' });
}

export function signInMessageForAuthStatus(response: Response, message: string): string | null {
  return response.status === 401 ? message : null;
}
